import React from "react";
import { useEffect, useState } from "react";
import { IndiaSec1 } from "./IndiaSec1/IndiaSec1";
import { IndiaSec1Data } from "../../../Data/IndiaSec1Data";
import { IndiaSec2 } from "./IndiaSec2/IndiaSec2";
import { MainLayout } from "../../MainLayout";
import { IndiaSec3 } from "./IndiaSec3/IndiaSec3";
import { Footer } from "../../Footer";
import { IndiaSec4 } from "./IndiaSec4/IndiaSec4";

export const India = () => {

    const topcitydata = [
        {
            id: 1, title: "New Delhi", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/delhi.webp", desc: [
                <p><strong>Why Visit: </strong>The capital of India, New Delhi, is a blend of rich history, political significance, and modern-day hustle and bustle. From ancient forts and tombs to modern shopping malls, Delhi offers something for everyone.</p>,
                <p><strong>Top Attractions: </strong>India Gate, Red Fort, Qutub Minar, Humayun’s Tomb, Lotus Temple, Akshardham Temple, and Chandni Chowk.</p>
            ]
        },
        {
            id: 2, title: "Mumbai", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/mumbai.webp", desc: [
                <p><strong>Why Visit: </strong>Mumbai, formerly known as Bombay, is the financial capital of India and is famous for its fast-paced lifestyle, film industry (Bollywood), and vibrant culture. The city is a melting pot of different cultures and offers incredible food, shopping, and nightlife.</p>,
                <p><strong>Top Attractions: </strong>Gateway of India, Marine Drive, Elephanta Caves, Chhatrapati Shivaji Terminus, Colaba Market, and Juhu Beach.</p>
            ]
        },
        {
            id: 3, title: "Jaipur", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/DMC%20India%20WebP/DMC%20India%20WebP/Top%20place/Top%20places%20Jaipur.webp", desc: [
                <p><strong>Why Visit: </strong>Known as the "Pink City" for its distinct pink-colored buildings, Jaipur is the capital of Rajasthan and is known for its majestic palaces, forts, and traditional markets.</p>,
                <p><strong>Top Attractions: </strong>Amber Fort, City Palace, Hawa Mahal, Jantar Mantar, Albert Hall Museum, and Jaipur Markets (especially Johari Bazaar).</p>
            ]
        },
        {
            id: 4, title: "Varanasi", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/varanasi.webp", desc: [
                <p><strong>Why Visit: </strong>One of the oldest cities in the world and a major religious hub, Varanasi, is considered the spiritual heart of India. It’s famous for its ghats (steps leading to the river), temples, and the sacred Ganges River.</p>,
                <p><strong>Top Attractions: </strong>Ganges Ghats, Kashi Vishwanath Temple, Dashashwamedh Ghat, Manikarnika Ghat, Sarnath, and boat rides on the Ganges.</p>
            ]
        },
        {
            id: 5, title: "Kolkata (Calcutta)", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/DMC%20India%20WebP/DMC%20India%20WebP/Top%20place/Top%20Places%20Kolkata.webp", desc: [
                <p><strong>Why Visit: </strong>Known as the "City of Joy," Kolkata is the cultural capital of India, with its colonial-era architecture, intellectual history, and vibrant arts scene. It offers a more relaxed pace compared to other major Indian cities.</p>,
                <p><strong>Top Attractions: </strong>Victoria Memorial, Howrah Bridge, Indian Museum, Marble Palace, Dakshineswar Kali Temple, and Eden Gardens.</p>
            ]
        },
        {
            id: 6, title: "Bangalore (Bengaluru)", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/DMC%20India%20WebP/DMC%20India%20WebP/Top%20place/Top%20palaces%20Bangalore.webp", desc: [
                <p><strong>Why Visit: </strong>Known as the "Silicon Valley of India," Bangalore is India’s tech hub. The city has a lively cultural scene, beautiful parks, and pleasant weather, making it a great destination for both work and leisure.</p>,
                <p><strong>Top Attractions: </strong>Lalbagh Botanical Garden, Bangalore Palace, Cubbon Park, Vidhana Soudha, and ISKCON Temple.</p>
            ]
        },
        {
            id: 7, title: "Chennai", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/DMC%20India%20WebP/DMC%20India%20WebP/Top%20place/Top%20places%20Chennai.webp", desc: [
                <p><strong>Why Visit: </strong>Chennai, the capital of Tamil Nadu, is known for its classical music and dance, temples, and coastal beauty. It is also a major hub for the automotive industry in India.</p>,
                <p><strong>Top Attractions: </strong>Marina Beach, Kapaleeshwarar Temple, Fort St. George, San Thome Basilica, and Breezy Beach.</p>
            ]
        },
        {
            id: 8, title: "Hyderabad", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/hyderabad.webp", desc: [
                <p><strong>Why Visit: </strong>Known as the "City of Pearls," Hyderabad is famous for its Mughal and Persian architecture, rich cuisine (notably biryani), and historical landmarks. It’s also a hub for the IT industry.</p>,
                <p><strong>Top Attractions: </strong>Charminar, Golconda Fort, Qutb Shahi Tombs, Hussain Sagar Lake, and Ramoji Film City.</p>
            ]
        },
        {
            id: 9, title: "Goa", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/DMC%20India%20WebP/DMC%20India%20WebP/Top%20place/Top%20Places%20Goa.webp", desc: [
                <p><strong>Why Visit: </strong>Known for its pristine beaches, vibrant nightlife, and Portuguese colonial influence, Goa is a favorite among travelers seeking relaxation, adventure, and great food.</p>,
                <p><strong>Top Attractions: </strong>Anjuna Beach, Baga Beach, Old Goa Churches, Fort Aguada, Basilica of Bom Jesus, and Dona Paula.</p>
            ]
        },
        {
            id: 10, title: "Udaipur", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/DMC%20India%20WebP/DMC%20India%20WebP/Top%20place/Top%20Places%20Udaipur.webp", desc: [
                <p><strong>Why Visit: </strong>Often called the "City of Lakes," Udaipur is one of the most romantic cities in India, with its tranquil lakes, palaces, and lush gardens. It offers a great mix of history and scenic beauty.</p>,
                <p><strong>Top Attractions: </strong>City Palace, Lake Pichola, Jag Mandir, Sajjangarh Monsoon Palace, and Fateh Sagar Lake.</p>
            ]
        },
        {
            id: 11, title: "Amritsar", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/DMC%20India%20WebP/DMC%20India%20WebP/Top%20place/Top%20places%20Amritsar.webp", desc: [
                <p><strong>Why Visit: </strong>Amritsar is home to the Golden Temple, one of the holiest sites in Sikhism. The city has a rich religious and cultural heritage, with vibrant markets and delicious Punjabi cuisine.</p>,
                <p><strong>Top Attractions: </strong>Golden Temple, Jallianwala Bagh, Wagah Border, Durgiana Temple, and Partition Museum.</p>
            ]
        },
        {
            id: 12, title: "Rishikesh", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/Top%20Places/rishikesh.webp", desc: [
                <p><strong>Why Visit: </strong>Rishikesh, located on the banks of the Ganges River, is known as the "Yoga Capital of the World." It attracts spiritual seekers, yoga enthusiasts, and adventure lovers.</p>,
                <p><strong>Top Attractions: </strong>Lakshman Jhula, Triveni Ghat, Neelkanth Mahadev Temple, Rajaji National Park, and Rishikesh Yoga Ashrams.</p>
            ]
        },
        {
            id: 13, title: "Pune", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/DMC%20India%20WebP/DMC%20India%20WebP/Top%20place/Top%20Places%20Pune.webp", desc: [
                <p><strong>Why Visit: </strong>Pune is known for its educational institutions, vibrant cultural scene, and pleasant weather. It is also home to a growing tech industry and great food culture.</p>,
                <p><strong>Top Attractions: </strong>Shaniwar Wada, Aga Khan Palace, Osho Ashram, Sinhagad Fort, and Katraj Snake Park.</p>
            ]
        },
        {
            id: 14, title: "Ahmedabad", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/DMC%20India%20WebP/DMC%20India%20WebP/Top%20place/Top%20places%20Ahemdabad.webp", desc: [
                <p><strong>Why Visit: </strong>Ahmedabad is known for its rich history, particularly related to Mahatma Gandhi, and is a vibrant center of business, textiles, and culture. The city has a great blend of modern and historical attractions.</p>,
                <p><strong>Top Attractions: </strong>Sabarmati Ashram, Sidi Saiyyed Mosque, Jama Masjid, Adalaj Stepwell, and Kankaria Lake.</p>
            ]
        },
        {
            id: 15, title: "Mysore", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/DMC%20India%20WebP/DMC%20India%20WebP/Top%20place/Top%20Places%20Mysore.webp", desc: [
                <p><strong>Why Visit: </strong>Mysore is a charming city known for its royal heritage, including its beautiful Mysore Palace. It is also famous for its yoga schools and the Dussehra Festival.</p>,
                <p><strong>Top Attractions: </strong>Mysore Palace, Chamundi Hill, St. Philomena’s Church, Brindavan Gardens, and Mysore Zoo.</p>
            ]
        },
        {
            id: 16, title: "Jaisalmer", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/DMC%20India%20WebP/DMC%20India%20WebP/Top%20place/Top%20Places%20Jaisalmer.webp", desc: [
                <p><strong>Why Visit: </strong>Located in the heart of the Thar Desert, Jaisalmer is known for its golden sandstone architecture, including the iconic Jaisalmer Fort. The city offers a unique desert experience with camel rides and stunning views of the sand dunes.</p>,
                <p><strong>Top Attractions: </strong>Jaisalmer Fort, Sam Sand Dunes, Patwon Ki Haveli, and Bada Bagh.</p>
            ]
        },
        {
            id: 17, title: "Lucknow", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/DMC%20India%20WebP/DMC%20India%20WebP/Top%20place/Top%20Places%20Lucknow.webp", desc: [
                <p><strong>Why Visit: </strong>Lucknow, the capital of Uttar Pradesh, is known for its Mughal and Awadhi heritage. The city offers a rich cultural experience, with beautiful gardens, mosques, and palaces.</p>,
                <p><strong>Top Attractions: </strong>Bara Imambara, Chota Imambara, Rumi Darwaza, Lucknow Zoo, and Hazratganj Market.</p>
            ]
        },
        {
            id: 18, title: "Khajuraho", img: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/DMC%20Destination/DMC%20India%20WebP/DMC%20India%20WebP/Top%20place/Top%20Places%20Khajuraho.webp", desc: [
                <p><strong>Why Visit: </strong>Khajuraho is famous for its stunning temples, known for their intricate and erotic carvings. It's a UNESCO World Heritage site and offers a glimpse into India’s ancient art and culture.</p>,
                <p><strong>Top Attractions: </strong>Khajuraho Group of Monuments, Lakshmana Temple, and Kandariya Mahadev Temple.</p>
            ]
        }

    ]

    const data = [
        {
            id: 1,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon1.png",
            title: "Custom India Itineraries",
            desc: "Your adventure, your way: Discover historical landmarks, relax on pristine beaches, or challenge yourself with Himalayan treks."
        },
        {
            id: 2,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon2.png",
            title: "Guided Tours",
            desc: "Our expert guides reveal India’s hidden depths. With their engaging style, you’ll explore India like a local, not just a tourist."
        },
        {
            id: 3,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon3.png",
            title: "Luxury Train Journeys",
            desc: "Learn India’s heritage in a unique style. Step into luxury journeys on iconic trains like Palace on Wheels or Maharaja’s Express."
        },
        {
            id: 4,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon4.png",
            title: "Cultural Experiences",
            desc: "Connect with India’s rich heritage: journey through temple visits, royal palaces, traditional dance performances, and cooking classes."
        },
        {
            id: 5,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon5.png",
            title: "Yoga & Wellness Retreats",
            desc: "Experience India’s ancient healing. From Rishikesh’s yoga to Kerala’s Ayurvedic gardens, relax your mind in peaceful surroundings."
        },
        {
            id: 6,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon6.png",
            title: "Adventure & Treks",
            desc: "Seek adventure in India’s wilds! From Rajasthan safaris to Ladakh treks, experience the thrill of these destinations."
        },
        {
            id: 7,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon7.png",
            title: "Food Tours & Experiences",
            desc: "Whatever your taste is, be it royal kitchens in Rajasthan or traditional cuisines in Kerala, savor the flavors that define India."
        },
        {
            id: 8,
            image: "/assets/icons/IndiaIcon/WhatWeOfferIcon8.png",
            title: "Spiritual Journeys",
            desc: "Find inner peace on sacred pilgrimages. Explore Varanasi, Bodh Gaya, and the Golden Temple for a transformative spiritual journey."
        },
    ];

    return (
        <>
            <MainLayout bgImage={'url("https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/Figma%20Images/Destination/Banner%203.webp")'}
                text2={"India"}
                button={true} />
            <IndiaSec1 IndiaSec1Data={IndiaSec1Data} />
            <IndiaSec2 countryCode="IN" />
            <IndiaSec3 data={topcitydata} name={"India"} />
            <IndiaSec4 data={data}
                heading={"Experiences We Offer Across India "}
            />
            <Footer />

        </>
    )


};